export class AuthInitiateAuthResponse {
  accountSts: number;
  personId?: string;
}
